module.exports = __webpack_public_path__ + "static/media/features2b@2x.cbcb04f2.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/features2b@2x.png
 ** module id = 903
 ** module chunks = 0
 **/